import(/* webpackMode: "eager" */ "/vercel/path0/src/app/wallet-test/page.tsx");
